import type { FC } from 'react';

import ExoticsRiskLadderModalContent from './exotics-risk-ladder-modal-content';

const ExoticsRiskLadderModalWidget: FC = () => <ExoticsRiskLadderModalContent />;

export default ExoticsRiskLadderModalWidget;
